"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  query ProductListingPagePagination(\n    $pageId: ID!\n    $channelType: EditorialChannelType!\n    $limit: Int!\n    $skip: Int\n    $orderBy: PlpOrderBy = Recommended\n    $facetFiltering: [EditorialPlpRowsFacetFilterInput!] = []\n    $hasFilters: Boolean = false\n  ) {\n    application {\n      editorialPage(pageId: $pageId, channelType: $channelType) {\n        contentItems {\n          __typename\n          ... on EditorialPlpRows {\n            content(top: $limit, skip: $skip, orderBy: $orderBy, facetFiltering: $facetFiltering) {\n              ...ProductListingRows\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productListingQueryPagination = void 0;
var _fetching = require("@ori/fetching");
var _productListingRows = require("./fragments/productListingRows");
const productListingQueryPagination = exports.productListingQueryPagination = (0, _fetching.gql)(_templateObject(), _productListingRows.productListingRows);
